import styled from "styled-components";
import { Colors } from '../../../assets/styles/StyleTypes'

export const DivSelectLangStyle = styled.div`
  position: relative;
  z-index: 4;
  & .selected {
    width: 100%;
    color: ${props => props.theme.colors.textHeader};
    padding: 5px;
    font-size: 16px;
    font-weight: 700;
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    

    span {
      white-space: nowrap;
    }
    .down-arrow {
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid ${props => props.theme.colors.textHeader};
    }

    .up-arrow {
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid ${props => props.theme.colors.textHeader};
    }
  }

  & .dropdown {    
    background-color: ${props => props.theme.colors.dropdownBackground};   
    margin: 0;
    padding-left: 0px;
    position: absolute;
    right: 8px;
    min-width: 110px;
    width: auto;  
    border-radius: 5px;
    box-shadow: ${props => props.theme.shadows.modalShadow};
    z-index: 4;
    
    li {    
      color: ${props => props.theme.colors.textPrimary};
      list-style-type: none;
      width: 100%;
      text-align: right;
      font-size: 12px;
      padding: 5px 15px;
      cursor: pointer;
      font-family: Roboto, sans-serif;

      :hover {
        background-color: ${props => props.theme.colors.dropdownHover};
      }
    }

    p {
      font-family: Roboto, sans-serif;
      font-size: 14px;
      padding: 5px 15px 0;
      text-align: right;
      font-weight: 700;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      max-width: 100%;
    }

  }

  @media screen and (max-width: 960px) {
    & .selected {
      color: ${Colors.HIGH_PURE};
      .down-arrow {
        border-top: 5px solid ${Colors.HIGH_PURE};
      }

      .up-arrow {
        border-bottom: 5px solid ${Colors.HIGH_PURE};
      }
    }

    & .dropdown {
      right: 0;
      left: 0;

      .notShowMobile{
        display: none;
      }

      li,
      p {
        text-align: left;
        padding-left: 15px;
      }
    }
  }
`;

